import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DropdownList } from 'react-widgets';
import CheckBox from '../../../../components/check-box';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Customer, Lead, WorkExperience } from '../../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import DateInput from '../../../../components/form-group/date-input';

const EmploymentType = [{ name: 'Full Time' }, { name: 'Part Time' }];
const TypeOfBusiness = [
  { name: 'Sole Proprietorship' },
  { name: 'Partnership' },
  { name: 'Limited Partnership' },
  { name: 'Corporation' },
  { name: 'Limited Liability Company' },
  { name: 'Nonprofit Organization' },
  { name: 'Cooperative (Co-op)' },
];
const Month = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

const Year: any[] | undefined = [];
for (
  let index = new Date().getFullYear() - 50;
  index < new Date().getFullYear() + 1;
  index++
) {
  Year.push({ label: index, value: index });
}

const WorkExperienceForm: React.FunctionComponent<{
  onSubmit: (experience: any) => void;
  onReset: () => void;
  customerDetails?: Customer;
  canUpdateCustomerExperiences?: boolean;
  fields: { displayName: string; value: string; type: string; group: string }[];
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    reset,
    watch,
    setValue,
  } = useForm<WorkExperience>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const currentWorkDetails = props.customerDetails?.workDetails
    ? props.customerDetails?.workDetails[
        props.customerDetails?.workDetails.length - 1
      ]
    : null;

  const isCurrentEmployer: boolean = (watch(
    'isCurrentEmployer'
  ) as unknown) as boolean;

  const startDate: Date = (watch('startDate') as unknown) as Date;

  const endDate: Date = (watch('startDate') as unknown) as Date;

  return props.customerDetails ? (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div>
        {!!props?.fields?.filter((x) => x.value === 'jobTitle')?.length &&
          !currentWorkDetails?.jobTitle && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Job Title<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="jobTitle"
                defaultValue={currentWorkDetails?.jobTitle}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Job Title"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="jobTitle"
                    disabled={!props.canUpdateCustomerExperiences}
                    // ref={(input) => input && input.focus()}
                  />
                )}
              />
              {errors.jobTitle && (
                <ErrorMessage>Job Title is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === 'employmentType')?.length &&
          !currentWorkDetails?.employmentType && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Employment Type<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                rules={{ required: true }}
                name="employmentType"
                defaultValue={currentWorkDetails?.employmentType}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={value}
                    data={EmploymentType}
                    defaultValue={value}
                    textField={'name'}
                    valueField={'name'}
                    placeholder={'Select Employment Type'}
                    onChange={(val) => {
                      onChange(val.name);
                    }}
                    disabled={!props.canUpdateCustomerExperiences}
                  />
                )}
              />
              {errors.employmentType && (
                <ErrorMessage>Employment Type is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === 'companyName')?.length &&
          !currentWorkDetails?.companyName && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Company<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="companyName"
                defaultValue={currentWorkDetails?.companyName}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Company"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="companyName"
                    disabled={!props.canUpdateCustomerExperiences}
                  />
                )}
              />
              {errors.companyName && (
                <ErrorMessage>Company is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === 'businessType')?.length &&
          !currentWorkDetails?.businessType && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Type Of Business
              </label>
              <Controller
                control={control}
                // rules={{ required: true }}
                name="businessType"
                defaultValue={currentWorkDetails?.businessType}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={value}
                    data={TypeOfBusiness}
                    defaultValue={value}
                    textField={'name'}
                    valueField={'name'}
                    placeholder={'Select Type Of Business'}
                    onChange={(val) => {
                      onChange(val.name);
                    }}
                    disabled={!props.canUpdateCustomerExperiences}
                  />
                )}
              />
              {errors.businessType && (
                <ErrorMessage>Type Of Business is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === 'location')?.length &&
          !currentWorkDetails?.location && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Location
              </label>
              <Controller
                control={control}
                // rules={{ required: true }}
                name="location"
                defaultValue={currentWorkDetails?.location}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Location"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="location"
                    disabled={!props.canUpdateCustomerExperiences}
                  />
                )}
              />
              {errors.location && (
                <ErrorMessage>Location is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === 'isCurrentEmployer')
          ?.length &&
          !currentWorkDetails?.isCurrentEmployer && (
            <div className="form-group font-weight-semibold mb-3 py-1">
              <Controller
                control={control}
                name="isCurrentEmployer"
                // rules={{ required: true }}
                defaultValue={currentWorkDetails?.isCurrentEmployer}
                render={({ onChange, value }) => (
                  <CheckBox
                    checked={value}
                    id={'isCurrentEmployer'}
                    onChange={onChange}
                    label={'I am currently working in this role'}
                    disabled={!props.canUpdateCustomerExperiences}
                  />
                )}
              />
            </div>
          )}

        <div className="row gutter-5">
          {!!props?.fields?.filter((x) => x.value === 'startDate')?.length &&
            !currentWorkDetails?.startDate && (
              <div className="col-sm-6 col-12">
                <div className="form-group font-weight-semibold mb-2">
                  <label htmlFor="" className="font-sm text-uppercase">
                    Start Date
                  </label>
                  <div className="row gutter-5">
                    <div className="col-12">
                      <Controller
                        control={control}
                        name="startDate"
                        defaultValue={currentWorkDetails?.startDate}
                        render={({ onChange, value, name }) => (
                          <DateInput
                            default={value}
                            placeholder={'mm/yyyy'}
                            onChange={(val) => {
                              onChange(val);
                              setValue('endDate', '');
                            }}
                            maxDate={endDate || new Date()}
                            dateFormat="MMMM  yyyy"
                            showMonthYearPicker={true}
                            showTwoColumnMonthYearPicker={true}
                            showFullMonthYearPicker={true}
                            disabled={!props.canUpdateCustomerExperiences}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          {!isCurrentEmployer &&
            !!props?.fields?.filter((x) => x.value === 'endDate')?.length &&
            !currentWorkDetails?.endDate && (
              <div className="col-sm-6 col-12">
                <div className="form-group font-weight-semibold mb-2">
                  <label htmlFor="" className="font-sm text-uppercase">
                    End Date
                  </label>
                  <div className="row gutter-5">
                    <div className="col-12">
                      <Controller
                        control={control}
                        name="endDate"
                        defaultValue={currentWorkDetails?.endDate}
                        render={({ onChange, value, name }) => (
                          <DateInput
                            default={value}
                            placeholder={'mm/yyyy'}
                            onChange={onChange}
                            minDate={startDate}
                            maxDate={new Date()}
                            dateFormat="MMMM  yyyy"
                            showMonthYearPicker={true}
                            showTwoColumnMonthYearPicker={true}
                            showFullMonthYearPicker={true}
                            disabled={!props.canUpdateCustomerExperiences}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            onClick={() => {
              reset({
                jobTitle: '',
                employmentType: '',
                companyName: '',
                businessType: '',
                location: '',
                isCurrentEmployer: '',
                startDate: '',
                endDate: '',
              });
              props.onReset();
            }}
            disabled={!props.canUpdateCustomerExperiences}
            title={
              !props.canUpdateCustomerExperiences
                ? 'No permisssion to update Work Experience'
                : ''
            }
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
          >
            Reset
          </button>
          <button
            disabled={!props.canUpdateCustomerExperiences}
            title={
              !props.canUpdateCustomerExperiences
                ? 'No permisssion to update Work Experience'
                : ''
            }
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  ) : (
    <></>
  );
};

export default WorkExperienceForm;
